<template>
  <div class="upload-content" v-if="showCamera">
    <div class="upload-cont">
      <div class="upload-cont-title">
        请选择您上传资料的方式
        <div class="close-btn" @click="closeModal()"></div>
      </div>
      <div class="upload-cont-btn-top" @click="triggerFileInput('image')">
        <div class="upload-icon"></div>
        <label class="upload-text">扫描（拍照或照片）</label>
        <input
          id="imageInput"
          ref="imageInput"
          type="file"
          accept="image/*"
          @change="handleImageUpload"
        />
      </div>
      <div class="upload-cont-btn-bottom" @click="triggerFileInput('file')">
        <div class="upload-icon"></div>
        <label class="upload-text"
          >文件（PDF文件）</label
        >
        <input
          id="fileInput"
          ref="fileInput"
          type="file"
          accept=".pdf"
          @change="handleFileUpload"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { compressImage } from "@/commons/imageCompress";

export default {
  props: {
   showCamera: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    triggerFileInput(type){
      if(type === 'image')this.$refs.imageInput.click()
      else if(type === 'file')this.$refs.fileInput.click();
    },
    async handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // 先关闭选择弹窗，避免压缩耗时期间界面停留
        this.closeModal()
        // 上传前先压缩：等比缩放到最大边长后重新编码（压缩失败时内部返回原文件）
        const imgFile = await compressImage(file);
        if (!imgFile) return; // 处理超时已提示"处理失败"，终止本次上传
        this.$emit("fileUploaded", imgFile, 'image');
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.$emit("fileUploaded", file, 'file');
        this.closeModal()
      }
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="less" scoped>
.upload-content {
  height: 100%;
  width: 18.75rem;
  position: fixed;
  top: auto;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.5);

  .upload-cont {
    padding: 0.75rem 0.75rem 0 0.75rem;
    width: 15.55rem;
    height: 7.03rem;
    margin: 0 auto; /* 添加水平居中 */
    position: relative; /* 改为相对定位 */
    background: #ffffff;
    border-radius: 0.6rem;
    margin-bottom: 1rem; /* 添加底部间距 */
    display: flex;
    flex-direction: column;
    align-items: center;
    .upload-cont-title {
      width: 15.55rem;
      text-align: center;
      height: 0.8rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 0.8rem;
      color: #333333;
      line-height: 0.8rem;
      .close-btn {
        background-size: 100% auto;
        background-repeat: no-repeat, no-repeat;
        background-image: url(https://res.xiaokunkeji.cn/image/2025/09/15/30e7b6a52e40464b9bc984e3e79547fb.png);
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        width: 0.7rem;
        height: 0.7rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
    #imageInput {
      display: none;
    }
    #fileInput {
      display: none;
    }
    .upload-cont-btn-top {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 1.03rem;
      margin-top: 1rem;
      padding-bottom: 0.8rem;
      border-bottom: 0.03rem solid #eaeaea;
      width: 14.55rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.65rem;
      color: #333333;
      line-height: 0.6rem;
      text-align: left;
      .upload-icon {
        height: 1rem;
        width: 1rem;
        margin-right: 0.4rem;
        background-size: 100% auto;
        background-repeat: no-repeat, no-repeat;
        background-image: url(https://res.xiaokunkeji.cn/image/2025/09/15/4f1550fb892549e2be747bc0de47ecd7.png);
      }
    }
    .upload-cont-btn-bottom {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 14.55rem;
      padding-left: 1.03rem;
      margin-top: 0.73rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 0.65rem;
      color: #333333;
      line-height: 0.6rem;
      text-align: left;
      .upload-icon {
        height: 1rem;
        width: 1rem;
        margin-right: 0.4rem;
        background-size: 100% auto;
        background-repeat: no-repeat, no-repeat;
        background-image: url(https://res.xiaokunkeji.cn/image/2025/09/15/eef17c59973c412f9d56035b962c9d78.png);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/camera.vue